import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { AlertTriangle } from "react-feather";

const VIOLATION_MESSAGES = {
  fullscreenExit: "You exited fullscreen mode. This quiz must be attempted in fullscreen.",
  tabSwitch: "You switched away from this tab/window. Stay on this page until you submit the quiz.",
  blockedShortcut: "That action/shortcut is disabled during a proctored quiz.",
};

const ProctoringWarningModal = ({ show, violationType, violationCount, onResume, container }) => {
  return (
    <Modal centered show={show} onHide={onResume} backdrop="static" keyboard={false} container={container}>
      <Modal.Header closeButton variant="white" className="bg-warning text-dark border-0">
        <Modal.Title className="fw-bold">
          <AlertTriangle size={24} className="me-2" />
          Proctoring Warning
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <p className="fs-5 mb-3">
          {VIOLATION_MESSAGES[violationType] || "A proctoring rule was violated."}
        </p>
        <Alert variant="danger" className="mb-0">
          This activity has been recorded. Total warnings: <strong>{violationCount}</strong>
        </Alert>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="primary" onClick={onResume} className="px-4 py-2 fw-bold">
          I Understand, Resume Quiz
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProctoringWarningModal;
